import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful';

export interface TypeBlockTextFields {
    internalName: EntryFieldTypes.Symbol;
    description?: EntryFieldTypes.RichText;
    colorOption?: EntryFieldTypes.Symbol<'color-light-grey' | 'color-no-background'>;
}

export type TypeBlockTextSkeleton = EntrySkeletonType<TypeBlockTextFields, 'blockText'>;
export type TypeBlockText<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
    TypeBlockTextSkeleton,
    Modifiers,
    Locales
>;

export function isTypeBlockText<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
    entry: unknown,
): entry is TypeBlockText<Modifiers, Locales> {
    const candidate = entry as { sys?: { contentType?: { sys?: { id?: string } } } };

    return candidate.sys?.contentType?.sys?.id === 'blockText';
}
